'use strict';
import * as $j_app$002epages$002e$002dDocuments$002dCreate$002dPage$0024$002dBased$002dOn from "./app.pages.-Documents-Create-Page$-Based-On.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_DocumentsCreatePage$BasedOn$AnotherDocument(kind, basedOn) {
  this.Mb = null;
  this.Ma = null;
  this.Mb = kind;
  this.Ma = basedOn;
}
export { $c_Lapp_pages_DocumentsCreatePage$BasedOn$AnotherDocument as $c_Lapp_pages_DocumentsCreatePage$BasedOn$AnotherDocument };
$p = $c_Lapp_pages_DocumentsCreatePage$BasedOn$AnotherDocument.prototype = new $j_app$002epages$002e$002dDocuments$002dCreate$002dPage$0024$002dBased$002dOn.$h_Lapp_pages_DocumentsCreatePage$BasedOn();
$p.constructor = $c_Lapp_pages_DocumentsCreatePage$BasedOn$AnotherDocument;
/** @constructor */
function $h_Lapp_pages_DocumentsCreatePage$BasedOn$AnotherDocument() {
}
export { $h_Lapp_pages_DocumentsCreatePage$BasedOn$AnotherDocument as $h_Lapp_pages_DocumentsCreatePage$BasedOn$AnotherDocument };
$h_Lapp_pages_DocumentsCreatePage$BasedOn$AnotherDocument.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_DocumentsCreatePage$BasedOn$AnotherDocument)) {
    var x = this.Mb;
    var x$2 = x$0.Mb;
    if ((x === x$2)) {
      var x$3 = this.Ma;
      var x$4 = x$0.Ma;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "AnotherDocument";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Mb;
  }
  if ((n === 1)) {
    return this.Ma;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "kind";
  }
  if ((n === 1)) {
    return "basedOn";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 0;
});
function $isArrayOf_Lapp_pages_DocumentsCreatePage$BasedOn$AnotherDocument(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.km)));
}
export { $isArrayOf_Lapp_pages_DocumentsCreatePage$BasedOn$AnotherDocument as $isArrayOf_Lapp_pages_DocumentsCreatePage$BasedOn$AnotherDocument };
var $d_Lapp_pages_DocumentsCreatePage$BasedOn$AnotherDocument = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_DocumentsCreatePage$BasedOn$AnotherDocument, "app.pages.DocumentsCreatePage$BasedOn$AnotherDocument", ({
  km: 1,
  fT: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_pages_DocumentsCreatePage$BasedOn$AnotherDocument as $d_Lapp_pages_DocumentsCreatePage$BasedOn$AnotherDocument };
//# sourceMappingURL=app.pages.-Documents-Create-Page$-Based-On$-Another-Document.js.map
